import React from 'react'
import Navbar from '../components/Navbar'
import EditTaskForm from '../components/EditTaskForm'
import { useParams } from 'react-router-dom'
import { useGetTaskQuery } from '../features/task/taskApi'

export default function EditTask() {
    const { taskId } = useParams() || {}

    const { isSuccess, isLoading, data: task } = useGetTaskQuery(taskId)

    return (
        <div>
            <Navbar />
            <div className="container relative">
                <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
                    <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
                        Edit Task for Your Team
                    </h1>

                    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
                        {!isLoading && isSuccess ?
                            <EditTaskForm task={task} /> : "Loading..."}
                    </div>
                </main>
            </div>
        </div>
    )
}
